import { render } from "./ColorPalette.vue?vue&type=template&id=7fdd9892&scoped=true"
import script from "./ColorPalette.vue?vue&type=script&lang=js"
export * from "./ColorPalette.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7fdd9892"

export default script